module.exports = __webpack_public_path__ + "images/thirteen-year-club-5e51e84d0c73abca00881ec52b035ba9.png";